import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHouseIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 22",
	style: { enableBackground: "new 0 0 24 22" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.house-icon-st0{fill:currentColor;}\n"
	}), /* @__PURE__ */ _jsx("path", {
		className: "house-icon-st0",
		d: "M20,6.1l-3-3V1h3V6.1z M24,12h-3v10H3V12H0L12,0L24,12z M14,14h-4v6h4V14z"
	})]
});
export default SvgHouseIcon;
